import { useContractFunction, useEthers } from "@usedapp/core";
import { constants, utils } from "ethers";
import { Contract } from "@ethersproject/contracts";
import AirdropDistributor from "@/chain-info/contracts/AirdropDistributor.json";
import NFTAirdropDistributor from "@/chain-info/contracts/NFTAirdropDistributor.json";
import useAccount from "@/hooks/useAccount";
import mixpanel from "mixpanel-browser";
import { useNetwork } from "wagmi";

export const useClaimAirdrop = (
  campaignType: string,
  distributorAddress: string | undefined
) => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const { abi: airdropDistributorAbi } = AirdropDistributor;
  const { abi: nftAirdropDistributorAbi } = NFTAirdropDistributor;
  const abi =
    campaignType === "TOKEN" ? airdropDistributorAbi : nftAirdropDistributorAbi;
  const contractInterface = new utils.Interface(abi);
  const contract = new Contract(
    distributorAddress ?? constants.AddressZero,
    contractInterface
  );

  const { state: claimAirdropState, send: claimAirdropSend } =
    useContractFunction(contract as any, "claim", {
      transactionName: "Claim Airdrop",
    });

  const claimAirdrop = (amount: string | null, merkleProof: string[]) => {
    mixpanel.track("claim_airdrop", {
      amount,
      merkleProof,
      distributorAddress,
      campaignType,
      address,
      chain,
    });
    if (!amount) {
      throw new Error("Amount is required");
    }
    return claimAirdropSend(address, amount, merkleProof); //FIXME Test super large amount for token
  };

  return {
    claimAirdrop,
    claimAirdropState,
  };
};
